var map = {
	"./barcode/adults-de.jpg": 4710,
	"./barcode/adults-de.png": 8546,
	"./barcode/adults-en-mini.png": 7556,
	"./barcode/adults-en.jpg": 8382,
	"./barcode/adults-en.png": 3034,
	"./barcode/adults-es.png": 255,
	"./barcode/adults-fr-mini.png": 5059,
	"./barcode/adults-fr.png": 7419,
	"./barcode/adults-mini-fr.png": 7417,
	"./barcode/adults-nl.png": 7901,
	"./jpg/C0-back.jpg": 1757,
	"./jpg/C0.jpg": 6149,
	"./jpg/C1.jpg": 8280,
	"./jpg/C10.jpg": 2738,
	"./jpg/C11.jpg": 2735,
	"./jpg/C12.jpg": 7776,
	"./jpg/C13.jpg": 4877,
	"./jpg/C14.jpg": 1526,
	"./jpg/C15.jpg": 2579,
	"./jpg/C16.jpg": 772,
	"./jpg/C17.jpg": 1678,
	"./jpg/C18.jpg": 9770,
	"./jpg/C19.jpg": 2423,
	"./jpg/C2.jpg": 5735,
	"./jpg/C20.jpg": 5623,
	"./jpg/C21.jpg": 3466,
	"./jpg/C22.jpg": 7605,
	"./jpg/C23.jpg": 2776,
	"./jpg/C24.jpg": 6379,
	"./jpg/C25.jpg": 542,
	"./jpg/C26.jpg": 9209,
	"./jpg/C27.jpg": 4860,
	"./jpg/C28.jpg": 8959,
	"./jpg/C29.jpg": 6290,
	"./jpg/C3.jpg": 9898,
	"./jpg/C30.jpg": 5224,
	"./jpg/C31.jpg": 7589,
	"./jpg/C32.jpg": 4986,
	"./jpg/C33.jpg": 9447,
	"./jpg/C34.jpg": 5100,
	"./jpg/C35.jpg": 6825,
	"./jpg/C36.jpg": 6766,
	"./jpg/C37.jpg": 7899,
	"./jpg/C38.jpg": 2432,
	"./jpg/C39.jpg": 8013,
	"./jpg/C4.jpg": 793,
	"./jpg/C40.jpg": 629,
	"./jpg/C41.jpg": 3016,
	"./jpg/C42.jpg": 1687,
	"./jpg/C5.jpg": 9740,
	"./jpg/C6.jpg": 1723,
	"./jpg/C7.jpg": 3678,
	"./jpg/C8.jpg": 8685,
	"./jpg/C9.jpg": 112,
	"./jpg/C99.jpg": 9583,
	"./png/C0-back-old.png": 1733,
	"./png/C0-images.png": 414,
	"./png/C0.png": 8897,
	"./png/C1.png": 8952,
	"./png/C10.png": 7530,
	"./png/C11.png": 7363,
	"./png/C12.png": 5384,
	"./png/C13.png": 7425,
	"./png/C14.png": 2862,
	"./png/C15.png": 8647,
	"./png/C16.png": 7964,
	"./png/C17.png": 9589,
	"./png/C18.png": 434,
	"./png/C19.png": 1979,
	"./png/C2.png": 5811,
	"./png/C20.png": 8331,
	"./png/C21.png": 7202,
	"./png/C22.png": 5385,
	"./png/C23.png": 6099,
	"./png/C24.png": 1327,
	"./png/C25.png": 2310,
	"./png/C26.png": 3549,
	"./png/C27.png": 2420,
	"./png/C28.png": 8339,
	"./png/C29.png": 9482,
	"./png/C3.png": 4234,
	"./png/C30.png": 704,
	"./png/C31.png": 1881,
	"./png/C32.png": 6738,
	"./png/C33.png": 5739,
	"./png/C34.png": 5796,
	"./png/C35.png": 8301,
	"./png/C36.png": 7622,
	"./png/C37.png": 5711,
	"./png/C38.png": 9160,
	"./png/C39.png": 9105,
	"./png/C4.png": 8533,
	"./png/C40.png": 5953,
	"./png/C41.png": 5736,
	"./png/C42.png": 8947,
	"./png/C5.png": 5644,
	"./png/C6.png": 4119,
	"./png/C7.png": 2782,
	"./png/C8.png": 1673,
	"./png/C9.png": 6848,
	"./png/C99-old.png": 2443,
	"./png/C99.png": 3715,
	"./png/trait.png": 6538,
	"./qr-code/qr-memo.png": 5058,
	"./qr-code/qr-siteweb-de.png": 6639,
	"./qr-code/qr-siteweb-en.png": 5763,
	"./qr-code/qr-siteweb-es.png": 6390,
	"./qr-code/qr-siteweb-fr.png": 6474,
	"./qr-code/qr-siteweb-pt.png": 7274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2729;